import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

export const shouldDisableBenefitsAutoplay = (slidesCount, viewportWidth) => (
  viewportWidth >= 1024 && slidesCount === 3
);

export const getBenefitsAutoplayConfig = (disabled) => {
  if (disabled) {
    return false;
  }

  return {
    delay: 4000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  };
};

const initBenefitsSwiper = (scope = document) => {
  const wrappers = scope?.querySelectorAll?.('.benefits-swiper-wr') ?? [];

  wrappers.forEach((el) => {
    const swiperEl = el.querySelector('.swiper');

    if (!swiperEl || swiperEl.swiper) {
      return;
    }

    const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

    if (!slidesCount) {
      return;
    }

    const nextEl = el.querySelector('.swiper-button-next');
    const prevEl = el.querySelector('.swiper-button-prev');
    const isDesktop = window.innerWidth >= 1024;
    const disableAutoplay = shouldDisableBenefitsAutoplay(slidesCount, window.innerWidth);
    const isTargetForInitialSlide = isDesktop && slidesCount >= 3;
    const swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      spaceBetween: 12,
      speed: 500,
      threshold: 10,
      initialSlide: isTargetForInitialSlide ? 1 : 0,
      allowTouchMove: !disableAutoplay,
      navigation: nextEl && prevEl ? {
        nextEl,
        prevEl,
      } : undefined,
      breakpoints: {
        389: {
          spaceBetween: 16,
        },
        641: {
          spaceBetween: 18,
        },
        961: {
          spaceBetween: 22,
        },
        1100: {
          spaceBetween: el.classList.contains('about-type') ? 23 : 32,
        },
        1200: {
          spaceBetween: el.classList.contains('about-type') ? 25 : 57,
        },
      },
      autoplay: getBenefitsAutoplayConfig(disableAutoplay),
    });

    if (!disableAutoplay) {
      swiperObserver(swiper);
    }

    window.addEventListener('resize', () => {
      requestAnimationFrame(() => {
        const shouldDisableNow = shouldDisableBenefitsAutoplay(slidesCount, window.innerWidth);

        swiper.allowTouchMove = !shouldDisableNow;

        if (shouldDisableNow && swiper.autoplay?.running) {
          swiper.autoplay.stop();
        }
      });
    });

    const wrapper = swiperEl.querySelector('.swiper-wrapper');

    if (!wrapper) {
      return;
    }

    const decorator = document.createElement('div');
    decorator.classList.add('benefits-swiper-decorator');
    wrapper.appendChild(decorator);

    let frameId = null;

    const updateDecorator = () => {
      if (frameId) {
        return;
      }

      frameId = requestAnimationFrame(() => {
        frameId = null;

        const slides = swiper.slides;

        if (!slides?.length) {
          return;
        }

        const first = slides[0];
        const last = slides[slides.length - 1];
        const start = first.offsetLeft + first.offsetWidth / 2;
        const end = last.offsetLeft + last.offsetWidth / 2;

        decorator.style.left = `${start}px`;
        decorator.style.width = `${end - start}px`;
      });
    };

    swiper.on('resize', updateDecorator);
    swiper.on('observerUpdate', updateDecorator);
    swiper.on('update', updateDecorator);
    updateDecorator();
  });
};

if (typeof document !== 'undefined') {
  initBenefitsSwiper();
}
